<div
  [ngClass]="{ 'one-error': list?.length === 1 }"
  class="errors-list"
  *ngIf="visible"
>
  <ul>
    <ng-template ngFor let-item [ngForOf]="list" let-i="index">
      <li>{{ item | titlecase }}</li>
    </ng-template>
  </ul>
</div>
